
/**
 * Export `isProduction`.
 */

export function isProduction(): boolean {
  return process.env.NODE_ENV === 'production'; // eslint-disable-line no-process-env
}
